import React, { Component } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation'
// import Slider from '../components/Slider'
import Carousel from '../components/Carousel'
import Case from '../components/Case'
import Products from '../components/Products'
// import Footer from '../components/Footer'
import SimpleFooter from '../components/SimpleFooter'
import About from '../components/About'
import News from '../components/News'

import config from '../dummy_data/configuration.json';

class HomePage extends Component {
	constructor () {
		super()
		this.state = {
			aboutItem: {},
			productLinesItems: [],
			footerItem: {},
			billboardItems: [],
			showMobileMenu: false
		}
	}

	componentWillMount() {
		this._getProductLines();
		this._getAbout();
		this._getFooter();
		this._getBillboards();
	}

	_getAbout = () => {
		axios({
	        method: 'GET',
	        url: config.aboutAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	aboutItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        });
	}

	_getFooter = () => {
		axios({
	        method: 'GET',
	        url: config.footerAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	footerItem: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getBillboards = () => {
		axios({
	        method: 'GET',
	        url: config.billboardAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            // console.log(res);
            this.setState({
            	billboardItems: res.data
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	_getProductLines = () => {
		axios({
	        method: 'GET',
	        url: config.productLinesAction,
	        responseType:'json',
	        headers: {'requestType': 'FN'}
	    }).then((res)=>{
            this.setState({
            	productLinesItems: res.data.map((item, i) => {
            		item.Image = config.rootSite + item.Image;
            		return item;
            	})
            });
        }).catch((err)=>{
            console.log(err.status);
        })
	}

	// switchLanguage(){
	// 	this.setState({
	//       isEnglish: !this.state.isEnglish
	//     });
	// }

	handleShowHideMobileMenu(){
		this.setState({
	      showMobileMenu: !this.state.showMobileMenu
	    });
	}

	handleScreenClick(event){
		//console.log(event.target.offsetParent);
		// if(event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
		// 	this.setState({
		//       showMobileMenu: false
		//     });
		// }
		if(event.target.tagName !== "A" && event.target.className !== "fa fa-bars" && event.target.className !== "navigation-folded" && event.target.offsetParent.className.indexOf("mobile") < 0){
			this.setState({
		      showMobileMenu: false
		    });
		}
	}

	getFontFamily = () =>{
		return localStorage.getItem("isEnglish") === "true"? 'myriad-pro-semi-condensed,Arial,sans-serif' : "Helvetica Neue,PingFang SC,Helvetica,Arial,Hiragino Sans GB,Microsoft Yahei,sans-serif";
	}
	

	render() {
		return(
			<div onClick={this.handleScreenClick.bind(this)} style={{fontFamily: this.getFontFamily()}}>
				<Navigation showMobileMenu={ this.state.showMobileMenu } handleShowHideMobileMenu={ this.handleShowHideMobileMenu.bind(this)}/>
				{/*<Slider items={this.state.billboardItems} />*/}
				<Carousel items={this.state.billboardItems} />
				<About item={this.state.aboutItem}/>
				<Products productLines={this.state.productLinesItems} />
				{/*<Case />
				<News />
				<Footer item={this.state.footerItem} />*/}
				<SimpleFooter item={this.state.footerItem} />
			</div>
		)
	}
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/pages/HomePage.js